import styles from './ProgressCard.module.scss';

interface ProgressCardProps {
  /** 0-1. */
  value: number;
  label: string;
  hint: string;
}

export function ProgressCard({ value, label, hint }: ProgressCardProps) {
  const percent = Math.round(Math.max(0, Math.min(value, 1)) * 100);

  return (
    <div className={styles.progress}>
      <div className={styles.row}>
        <span>Your progress</span>
        <strong>{label}</strong>
      </div>
      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Workshop progress"
      >
        <span className={styles.fill} style={{ width: `${percent}%` }} />
      </div>
      <small className={styles.hint}>{hint}</small>
    </div>
  );
}
